module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ../app_shared/~/apollo-link-context/~/zen-observable/index.js
// module id = 467
// module chunks = 1